export default "__VITE_ASSET__b69b65e0__"